/**
 * @generated SignedSource<<275d6d1ac999554b5bbbbd7e03130542>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InsertAnswersInput = {
  answers: ReadonlyArray<string>;
  clientMutationId?: string | null;
  elementId: string;
  position: number;
};
export type GridQuestionEditor_insertColumns_Mutation$variables = {
  input: InsertAnswersInput;
};
export type GridQuestionEditor_insertColumns_Mutation$data = {
  readonly insertAnswers: {
    readonly element: {
      readonly answers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly position: number;
            readonly text: string | null;
          } | null;
        } | null>;
      };
    } | null;
  } | null;
};
export type GridQuestionEditor_insertColumns_Mutation = {
  response: GridQuestionEditor_insertColumns_Mutation$data;
  variables: GridQuestionEditor_insertColumns_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GridQuestionEditor_insertColumns_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InsertAnswersPayload",
        "kind": "LinkedField",
        "name": "insertAnswers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementNode",
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AnswerNodeConnection",
                "kind": "LinkedField",
                "name": "answers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GridQuestionEditor_insertColumns_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InsertAnswersPayload",
        "kind": "LinkedField",
        "name": "insertAnswers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ElementNode",
            "kind": "LinkedField",
            "name": "element",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AnswerNodeConnection",
                "kind": "LinkedField",
                "name": "answers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AnswerNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "36e20e6466994ae1f23110cf41271361",
    "id": null,
    "metadata": {},
    "name": "GridQuestionEditor_insertColumns_Mutation",
    "operationKind": "mutation",
    "text": "mutation GridQuestionEditor_insertColumns_Mutation(\n  $input: InsertAnswersInput!\n) {\n  insertAnswers(input: $input) {\n    element {\n      answers {\n        edges {\n          node {\n            text\n            position\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b69b0b1ba67503d1c665ae3e41d5742d";

export default node;
